import React from "react";
import { useEffect } from "react";
import { useState } from "react";

const SurveyOpenQuestion = ({ question, answer, answerSetter, selectedPersonnel }) => {
  const [value, setValue] = useState("");

  useEffect(() => {
    const isAnswered = answer
      .filter((_answer) => _answer?.taggedId === selectedPersonnel?.taggedId)
      .filter((_answer) => _answer?.branchInfo?.id === selectedPersonnel?.branch)
      .find((_question) => _question?.questionId === question?.id);
    if (isAnswered) {
      setValue(isAnswered?.questionText || "");
    } else {
      setValue("");
    }
  }, [JSON.stringify(question), JSON.stringify(selectedPersonnel)]);

  const onBlur = () => {
    answerSetter(question, value, "OPEN");
  };

  return (
    <div className="form-group">
      <textarea
        key={selectedPersonnel?.taggedId + question?.id}
        className="form-control"
        rows="3"
        value={value}
        onChange={(e) => setValue(e.target.value)}
        onBlur={onBlur}
        type="text"
      ></textarea>
    </div>
  );
};

export default SurveyOpenQuestion;
